// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#circle-top[data-v-1b57393b] {
  position: absolute;
  width: 884px;
  height: 884px;
  left: 665px;
  top: -525px;
  background: #f1eefd;
  filter: blur(200px);
}
#circle-bottom[data-v-1b57393b] {
  position: absolute;
  width: 698px;
  height: 698px;
  left: 674px;
  top: 665px;
  background: #ccd9ff;
  filter: blur(350px);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
